import { render, staticRenderFns } from "./firstAccessPage.vue?vue&type=template&id=2cb3beed"
import script from "./firstAccessPage.vue?vue&type=script&lang=js"
export * from "./firstAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports